import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getTodayTimework } from '../utils'
import paths from '../routes/paths'
import { setAgreeOvertime } from '../actions/appActions'

import ModalOvertime from '../components/order/ModalOvertime'
import useTimeWork from '../hooks/useTimeWork'
import { useDispatch, useSelector } from 'react-redux'

const ModalOvertimeContainer = () => {
    const { isOvertime } = useTimeWork()
    const isReady = useSelector(state => state.RestaurantReducer.isReady);
    const [showOvertime, setShowOvertime] = useState()
    const todayTimeWork = getTodayTimework()
        .filter(time => time !== '00:00-00:00')
        .map(frame => frame.split('-'))
    const location = useLocation()
    const dispatch = useDispatch()

    const getMessageOvertime = () => {
        if (isReady === false) {
            return {
                message: 'modalOverTime.messageNotReady'
            };
        }

        switch (todayTimeWork.length) {
            case 0: {
                return {
                    message: 'modalOverTime.messageTodayOff'
                }
            }
            case 1: {
                return {
                    message: 'modalOverTime.messageTimeworkFrame1',
                    messageParams: {
                        from: todayTimeWork[0][0],
                        to: todayTimeWork[0][1]
                    }
                }
            }
            case 2: {
                return {
                    message: 'modalOverTime.messageTimeworkFrame2',
                    messageParams: {
                        from1: todayTimeWork[0][0],
                        to1: todayTimeWork[0][1],
                        from2: todayTimeWork[1][0],
                        to2: todayTimeWork[1][1],
                    }
                }
            }
            default: {
                return {}
            }
        }
    }

    const handleClose = () => {
        setShowOvertime(false)
        dispatch(setAgreeOvertime())
    }

    useEffect(() => {
        const { pathname } = location
        if (
            isOvertime &&
            showOvertime === undefined &&
            !pathname.includes(paths.notFound) &&
            !pathname.includes(paths.unSupport)
        ) {
            setShowOvertime(true)
        }
    }, [isOvertime])

    return (
        <ModalOvertime
            isOpen={showOvertime}
            onClose={handleClose}
            {...getMessageOvertime()}
        />
    )
}

export default ModalOvertimeContainer
